import { render, staticRenderFns } from "./PersonColumnFilter.vue?vue&type=template&id=547e76d6&scoped=true&"
import script from "./PersonColumnFilter.vue?vue&type=script&lang=js&"
export * from "./PersonColumnFilter.vue?vue&type=script&lang=js&"
import style0 from "./PersonColumnFilter.vue?vue&type=style&index=0&id=547e76d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547e76d6",
  null
  
)

export default component.exports